import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import type {Fact} from '../../components/facts-list';

import type {BLOCK_TYPE_FACTS_LIST} from './constants';

export const FACTS_LIST_FRAGMENT = `//groq
	...
`;

export type FactsListFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_FACTS_LIST}
>;

export const factsFromFactListFragment = (data: FactsListFragment): KeyedArray<Fact> => {
	const facts: KeyedArray<Fact> = [];

	if (data.facts) {
		for (const fact of data.facts) {
			facts.push({
				_key: fact._key,
				title: fact.title ?? '',
				description: fact.description,
			});
		}
	}

	return facts;
};
